import { RouteConfig } from 'vue-router';
const Home = () => import('./home.vue');
const Export = () => import('../export/export.vue');
const Manage = () => import('../manage/manage.vue');
import ManageRouterChildren from '../manage/manage.router';
import ExportRouterChildren from '../export/export.router';
const routers: RouteConfig[] = [
    {
        path: 'home',
        component: Home,
    },
    {
        path: 'manage',
        component: Manage,
        children: ManageRouterChildren
    },
    {
        path: 'export',
        component: Export,
        children: ExportRouterChildren
    },
];
export default routers;

